// カードを新規追加するモーダルのコンポーネント

import React, { useState } from 'react';

import './UserMailModal.css';

// React Modalで実装
import Modal from 'react-modal';

import { useEffect } from 'react';
import { useTranslation } from "react-i18next";

const UserMailModal = ({userMailModalIsOpen, closeAndResetModal, userInfo, setUserInfo}) => {
    const { t } = useTranslation();
    const [userMailPage, setUserMailPage] = useState(1);
    
    const moveNextPage = () => {
        if (!userInfo.title) {
            alert(t('user_mail_modal.error1'));
            return;
        }
        if (!userInfo.point) {
            setUserInfo({...userInfo, point: 0});
        }

        setUserMailPage(2);
    }

    const movePrevPage = () => {
        setUserMailPage(1);
    }

    const completeUserMail = () => {
        let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
        if (xsrfToken) {
            xsrfToken = xsrfToken.split('=')[1]
        }
        let token = document.cookie.split('; ').find(row => row.startsWith('token'));
        if (token) {
            token = token.split('=')[1]
        }

        fetch(`${process.env.REACT_APP_API_URL}/api/user/mail/${userInfo.id}`, {
            method: 'POST',
            cache: 'no-store',
            headers: {
                'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                'Bearer': decodeURIComponent(token),
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                title: userInfo.title,
                point: userInfo.point,
                content: userInfo.content
            })
        })
        .then(res => {
            if (res.status === 200) {
                alert(t('user_mail_modal.complete'));
                setUserInfo({
                    id: '',
                    title: '',
                    point: 0,
                    content: ''
                });
                setUserMailPage(1);
                closeAndResetModal();
            } else {
                alert(t('user_mail_modal.error2'));
            }
        })
        .catch(error => {
            alert(t('user_mail_modal.error3'));
            console.error(error);
        });
    }

    const closeModal = () => {
        setUserMailPage(1);
        closeAndResetModal();
    }

    return (
        <>
            { userMailPage === 1 &&
                <>
                    <UserMailModal1
                        modalIsOpen = {userMailModalIsOpen}
                        closeModal = {closeModal}
                        moveNextPage = {moveNextPage}
                        userInfo={userInfo}
                        setUserInfo={setUserInfo}
                    />
                </>
            }
            { userMailPage === 2 &&
                <>
                    <UserMailModal2
                        modalIsOpen = {userMailModalIsOpen}
                        closeModal = {closeModal}
                        movePrevPage = {movePrevPage}
                        completeUserMail = {completeUserMail}
                        userInfo={userInfo}
                        setUserInfo={setUserInfo}
                    />
                </>
            }
        </>
    );
}

export default UserMailModal;


const UserMailModal1 = ({modalIsOpen, closeModal, moveNextPage, userInfo, setUserInfo}) => {
    const { t } = useTranslation();
    return (
        <>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="user-mail-modal"
            overlayClassName="user-mail-modal-overlay"
            contentLabel="Example Modal"
        >
            <div className="user-mail-modal-title">{t('user_mail_modal.title')}</div>
            <div className='progressbar-mini-box'>
                <ul className="progressbar-mini">
                    <li className="active"></li>
                    <li></li>
                </ul>
            </div>
            <div className="clearfix"></div>
            <div className="user-mail-modal-form">
                <div className="user-mail-modal-form-title">{t('user_mail_modal.user')}</div>
                <div className="user-mail-modal-form-content">{userInfo.email}</div>
                <div className="user-mail-modal-form-title">{t('user_mail_modal.point')}</div>
                <div className="user-mail-modal-form-content">
                    <input className="user-mail-modal-form-content-input user-mail-modal-form-content-input-half" type="number" name="point" value={userInfo.point} onChange={e => setUserInfo({...userInfo, point: e.target.value})} defaultValue="0"/> pt
                </div>
                <div className="user-mail-modal-form-title">{t('user_mail_modal.mail_title1')}</div>
                <div className="user-mail-modal-form-content">
                    <input className="user-mail-modal-form-content-input" type="text" name="title" value={userInfo.title} onChange={e => setUserInfo({...userInfo, title: e.target.value})} placeholder={t('user_mail_modal.mail_title2')}/>
                </div>
                <div className="user-mail-modal-form-title">{t('user_mail_modal.mail_derail1')}</div>
                <div className="user-mail-modal-form-content">
                    <textarea className="user-mail-modal-form-content-textarea" name="content" value={userInfo.content} onChange={e => setUserInfo({...userInfo, content: e.target.value})} placeholder={t('user_mail_modal.mail_derail2')}></textarea>
                </div>
            </div>

            <div className="user-mail-modal-button">
            <button className="user-mail-modal-button-cancel" onClick={closeModal}>{t('user_mail_modal.back')}</button>
            <button className="user-mail-modal-button-add" onClick={moveNextPage}>{t('user_mail_modal.next')}</button>
            </div>
        </Modal>
        </>
    );
}

const UserMailModal2 = ({modalIsOpen, closeModal, completeUserMail, movePrevPage, userInfo, setUserInfo}) => {
    const { t } = useTranslation();
    return (
        <>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="user-mail-modal"
            overlayClassName="user-mail-modal-overlay"
            contentLabel="Example Modal"
        >
            <div className="user-mail-modal-title">{t('user_mail_modal.title')}</div>
            <div className='progressbar-mini-box'>
                <ul className="progressbar-mini">
                    <li className="active"></li>
                    <li></li>
                </ul>
            </div>
            <div className="clearfix"></div>
            <div className="user-mail-modal-form">
                <div className="user-mail-modal-form-title">{t('user_mail_modal.user')}</div>
                <div className="user-mail-modal-form-content">{userInfo.email}</div>
                <div className="user-mail-modal-form-title">{t('user_mail_modal.point')}</div>
                <div className="user-mail-modal-form-content">
                    {userInfo.point} pt
                </div>
                <div className="user-mail-modal-form-title">{t('user_mail_modal.mail_title1')}</div>
                <div className="user-mail-modal-form-content">
                    {userInfo.title}
                </div>
                <div className="user-mail-modal-form-title">{t('user_mail_modal.mail_derail1')}</div>
                <div className="user-mail-modal-form-content">
                    <textarea className="user-mail-modal-form-content-textarea" name="content" value={userInfo.content} onChange={e => setUserInfo({...userInfo, content: e.target.value})} readOnly/>
                </div>
            </div>
            <div className="line"></div>
            <div className="user-mail-subtitle">{t('user_mail_modal.confirm')}</div>
            <div className="user-mail-description"><span class="user-mail-note-icon">!</span> {t('user_mail_modal.note1')}<br />{t('user_mail_modal.note2')}<br/>({t('user_mail_modal.note3')})</div>

            <div className="user-mail-modal-button">
            <button className="user-mail-modal-button-cancel" onClick={movePrevPage}>{t('user_mail_modal.back')}</button>
            <button className="user-mail-modal-button-add" onClick={completeUserMail}>{t('user_mail_modal.give')}</button>
            </div>
        </Modal>
        </>
    );
}